import React, { useRef } from 'react';
import styles from './index.module.scss';
import { useScreenSlideIn } from '@/hooks/useScreenSlideIn';
import screen6Background from '@/assets/home/new-screen6-background.png';
import screen6BgPeople from '@/assets/home/new-screen6-bg-people.png';
import screen6Circle from '@/assets/home/new-screen6-circle.png';
import screen6Earth from '@/assets/home/new-screen6-earth.png';
import screen6Phone from '@/assets/home/new-screen6-phone.png';
import screen6Star from '@/assets/home/new-screen6-star.png';

export default function Screen6() {
  const screenRef = useRef<HTMLDivElement>(null);

  const slideInRef = useScreenSlideIn({
    triggerSlideRatio: 0.8,
    animationClassName: styles['screen6-anim-start'],
  });

  return (
    <section
      className={styles['screen6-cover']}
      ref={slideInRef.ref}
      style={{ backgroundImage: `url(${screen6Background})` }}
    >
      <div className={styles['screen6-wrap']} ref={screenRef}>
        {/* 标题 */}
        <div className={styles['screen6-title-container']}>
          <h2 className={styles['screen6-title']}>AI核心技术</h2>
        </div>

        {/* 三个功能卡片 */}
        <div className={styles['screen6-cards']}>
          {/* 左侧卡片 */}
          <div className={`${styles['screen6-card-wrapper']} ${styles['screen6-card-1-wrapper']}`}>
            <div className={styles['screen6-card']}>
              <div className={styles['screen6-card-icon']}>
                <img src={screen6Earth} alt="高并发" loading="lazy" />
              </div>
              <div className={styles['screen6-card-content']}>
                <h3 className={styles['screen6-card-title']}>高并发</h3>
                <p className={styles['screen6-card-desc']}>支持万人并发，系统稳定性高</p>
              </div>
            </div>
          </div>

          {/* 右上卡片 */}
          <div className={`${styles['screen6-card-wrapper']} ${styles['screen6-card-2-wrapper']}`}>
            <div className={styles['screen6-card']}>
              <div className={styles['screen6-card-icon']}>
                <img src={screen6Circle} alt="低延时" loading="lazy" />
              </div>
              <div className={styles['screen6-card-content']}>
                <h3 className={styles['screen6-card-title']}>低延时</h3>
                <p className={styles['screen6-card-desc']}>200FPS端云协同推理</p>
              </div>
            </div>
          </div>

          {/* 右下卡片*/}
          <div className={`${styles['screen6-card-wrapper']} ${styles['screen6-card-3-wrapper']}`}>
            <div className={styles['screen6-card']}>
              <div className={styles['screen6-card-icon']}>
                <img src={screen6Phone} alt="全适配" loading="lazy" />
              </div>
              <div className={styles['screen6-card-content']}>
                <h3 className={styles['screen6-card-title']}>全适配</h3>
                <p className={styles['screen6-card-desc']}>中端手机到高端VR无缝覆盖</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img
        className={styles['screen6-bg-people']}
        src={screen6BgPeople}
        alt=""
        aria-hidden
        loading="lazy"
      />
    </section>
  );
}
